import React from 'react';
export const SidebarInbox = ({ size = 16, className, 'data-testid': testId, fill = 'currentColor', 'aria-label': ariaLabel, }) => {
    return (React.createElement("svg", { "aria-label": ariaLabel, className: className, "data-testid": testId, fill: "none", height: size, width: size, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fill: fill, d: "M13 2.5H2v12h12v-12h-1Zm0 11H3v-3h2l1.176 1.283a.994.994 0 0 0 .707.293h2.586a.992.992 0 0 0 .707-.294L11 10.5h2v3Z" })));
};
